<sbnb-apps-detail-page
  vendorCode="safely"
  name="Safely"
  logoTile="/assets/images/apps/safely.svg"
  builtBy="Safely"
  builtByLink="https://www.safely.com/"
  [categories]="['Guest verification']"
  email="concierge@safely.com"
  [helpLink]="{
    href: 'https://safely.com/?utm_source=hospitable%20&utm_campaign=partner_website&utm_medium=referral',
    text: 'Get short-term rental protection from Safely'
  }"
  [helpArticles]="[
    {
      id: '10982824',
      title: 'Connect Hospitable with Safely for Guest Screening and Insurance'
    }
  ]"
  [permissions]="[
    AppPermission.propertyListingRead,
    AppPermission.reservationRead,
    AppPermission.financialsRead,
    AppPermission.calendarRead
  ]">
  <ng-container description>
    <p class="strong">Damage &amp; Liability Insurance &bull; Guest Screening &bull; Travel Insurance</p>
    <p>
      Safely protects short-term rentals with rigorous guest screening and up to $1,000,000 of commercial vacation
      rental insurance coverage provided by On Demand Insurance Agency, LLC. Safely brings confidence and peace of mind
      to property managers as they grow revenue, reduce risk, and provide a superior guest experience. Based in Atlanta,
      Safely has protected over $100 billion in homeowner liability coverage and over three million guest nights.
    </p>
    <strong>Safely's Competitive Advantage:</strong>
    <ul class="list list__looser">
      <li>
        Low Deductible: Coverage for the most common recurring operational costs, including soiled linens, broken
        dishware, and more.
      </li>
      <li>Per-Night Coverage: Only pay for the nights you have guests.</li>
      <li>
        Little Guest Involvement: In most cases guests are not involved in making a claim, creating strong guest
        relationships and reducing the potential for bad reviews.
      </li>
      <li>
        Guest Risk Score: Access to our exclusive database of renters with a history of damaging short-term rentals.
      </li>
      <li>
        Coverage Without Conditions: You decide which guests you allow. We will never deny coverage based on guest
        screening results.
      </li>
      <li>Earn Revenue On Each Reservation: The guest pays for all costs instead of a damage deposit.</li>
    </ul>

    <strong>Travel Insurance</strong>
    <p>
      Travel Insurance protects up to 100% of a guest's vacation investment for covered reasons such as illness
      (including contracting COVID), injury or death in the family or to someone in the traveling party, natural
      disasters (not COVID-related shutdowns), travel delays and much more.
      <a href="https://www.safely.com/travel-insurance" target="_blank" class="link">
        Learn more about Travel Insurance
      </a>
    </p>
  </ng-container>
  <sbnb-image-carousel
    [images]="[
      '/assets/images/apps/safely/image-1.png',
      '/assets/images/apps/safely/image-2.png',
      '/assets/images/apps/safely/image-3.png',
      '/assets/images/apps/safely/image-4.png',
      '/assets/images/apps/safely/image-5.png',
      '/assets/images/apps/safely/image-6.png',
      '/assets/images/apps/safely/image-7.png',
      '/assets/images/apps/safely/image-8.png',
      '/assets/images/apps/safely/image-9.png',
      '/assets/images/apps/safely/image-10.png'
    ]"></sbnb-image-carousel>
</sbnb-apps-detail-page>
